import React from 'react'

import InputGroup, { CheckboxValue } from 'components/shared/InputGroup'
import { useStoreActions, useStoreState } from 'store'

const options = [
  { value: 'PrimaryResidence', label: 'Primary' },
  { value: 'SecondaryOrVacation', label: 'Secondary' },
  { value: 'InvestmentOrRental', label: 'Rental' },
]

export default function PropertyUse() {
  const {
    mortgageType,
    purchase: { propertyUse: purchasePropertyUse },
    refinance: { propertyUse: refinancePropertyUse },
  } = useStoreState(state => state.dimensions.dimensions)
  const { onInputTracking } = useStoreActions(actions => actions.tracking)
  const { updateDimensions } = useStoreActions(actions => actions.dimensions)

  const handleChange = (propertyUse: CheckboxValue) => {
    const updateObj: {
      [key: string]: { propertyUse: CheckboxValue }
    } = {}
    updateObj[mortgageType.toLowerCase()] = { propertyUse }
    updateDimensions(updateObj)
    onInputTracking({ name: 'propertyuse', label: 'property use', value: propertyUse.toString() })
  }

  return (
    <>
      <div className="form-element-container mb-2">
        <div className="FormLabel mb-1">Property use</div>
        <InputGroup
          data-testid="propertyUse"
          options={options}
          className="FormButtonGroup FormButtonGroup--small FormButtonGroup--fill mb-4"
          value={mortgageType === 'Purchase' ? purchasePropertyUse : refinancePropertyUse}
          onClick={handleChange}
        />
      </div>
    </>
  )
}
